import { Component, Input } from '@angular/core';
import { StudentFormModalComponent } from "../student-components/student-form-modal/student-form-modal.component";
import { StaffCommonFormModalComponent } from "../staff-common-form-modal/staff-common-form-modal.component";

@Component({
  selector: 'app-staff-student-common-profile-view',
  standalone: true,
  imports: [StudentFormModalComponent, StaffCommonFormModalComponent],
  templateUrl: './staff-student-common-profile-view.component.html',
  styleUrl: './staff-student-common-profile-view.component.css'
})
export class StaffStudentCommonProfileViewComponent {

  @Input() profileData: any = {};
  @Input() isStudent: boolean = false;

  isModelOpen: boolean = false;
  editRecordId: number | string | null = null;
  editUserType: 'HOD' | 'TEACHER' | 'STAFF' | null = null;

  getAddress(type: 'current' | 'permanent') {
    if (!Array.isArray(this.profileData?.address)) {
      return null;
    }
    return this.profileData.address.find((a: any) => a?.address_type === type) || null;
  }

  openEditModal() {
    this.editRecordId = this.profileData?.id ?? this.profileData?.student_id ?? this.profileData?.user_id ?? null;
    this.editUserType = this.resolveUserType(this.profileData);
    this.isModelOpen = true;
  }

  closeEditModal() {
    this.isModelOpen = false;
    this.editRecordId = null;
    this.editUserType = null;
  }

  private resolveUserType(profile: any): 'HOD' | 'TEACHER' | 'STAFF' | null {
    const roleName = String(profile?.role?.name ?? profile?.role?.alias ?? profile?.role_name ?? '').trim().toUpperCase();
    if (roleName === 'HOD' || roleName === 'TEACHER' || roleName === 'STAFF') {
      return roleName;
    }
    return null;
  }



}
